import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputMultiselectComponent } from './input-multiselect.component';
import { MultiSelectModule } from 'primeng/multiselect';


@NgModule({
  declarations: [
    InputMultiselectComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule,
    MultiSelectModule
  ],
  exports: [
    InputMultiselectComponent
  ]
})
export class InputMultiselectModule {
}
